module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iIzAwNzMyZiIgZD0iTTAgMGg1MTJ2MTcwLjY2N0gweiIvPgogIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDE3MC42NjdoNTEydjE3MC42NjdIMHoiLz4KICA8cGF0aCBkPSJNMCAzNDEuMzMzaDUxMlY1MTJIMHoiLz4KICA8cGF0aCBmaWxsPSJyZWQiIGQ9Ik0wIDBoMTgwdjUxMkgweiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/ae.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/ae.svg
// module chunks = 0